// extracted by mini-css-extract-plugin
module.exports = {"inputText":"inputTextArea_inputText__2AbG8","inputMessage":"inputTextArea_inputMessage__30t6Z"};